<div class="app-empty-state">
  <ng-lottie [options]="animationOptions" width="280px" height="280px"></ng-lottie>
  <h3>{{ title }}</h3>
  <p>{{ message }}</p>
</div>
